import React from "react";
import classNames from "../../classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function TIN({
  className,
  _type,
  type,
  strict,
  onChange,
  uppercase,
  ...props
}) {
  function onInput(e) {
    let value = e.target.value;

    // Remove all non-numeric characters
    value = value.replace(/\D/g, "");

    // Insert dash every third digit
    value = value.replace(/(\d{3})(?=\d)/g, "$1-");

    // Trim extra dash at the end
    value = value.replace(/-$/, "");

    // Enforce limit of characters
    const limit = 15; // Example limit of 14 characters
    if (value.length > limit) {
      value = value.substring(0, limit);
    }

    if (uppercase) {
      value = value.toUpperCase();
    }

    e.target.value = value;
    onChange(value);
  }

  return (
    <div>
      <input
        className={classNames("form-control", className)}
        onInput={onInput}
        {...props}
      />
      <br />
    </div>
  );
}
TIN.defaultProps = defaultProps;
export default TIN;
